var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgUnpin = function SvgUnpin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.368 7.149l-.008.013-5.247-5.247a.847.847 0 10-1.198 1.198L7.02 8.218l-.598.271-.442-.442a1.667 1.667 0 00-2.357 0l-.59.59c-.65.65-.65 1.706 0 2.357l1.943 1.942-3.183 4.29a.644.644 0 00.901.9l4.29-3.182 1.942 1.942c.651.651 1.707.651 2.357 0l.59-.589c.65-.65.65-1.706 0-2.357l-.295-.295.326-.543 4.983 4.983a.847.847 0 101.198-1.198l-5.078-5.078.012-.008-1.201-1.202-.013.008-2.23-2.23.008-.013-1.215-1.215zm4.887 2.491l1.54-1.027 1.202 1.202.59-.59-5.893-5.892-.59.59 1.231 1.23-.899 1.669-1.23-1.23.074-.137-.354-.354a1.667 1.667 0 010-2.357l.59-.59c.65-.65 1.706-.65 2.357 0l5.892 5.893c.651.651.651 1.707 0 2.357l-.59.59c-.65.65-1.705.65-2.356 0l-.236-.236-.126.084-1.202-1.202zm-3.776 4.264l1.21-2.017-2.411-2.411-.057.026-2.16.982L4.8 9.227l-.589.59 5.893 5.892.59-.59-1.216-1.214z",
    fill: "#fff"
  })));
};

export default SvgUnpin;